import backgroundAxiosInstance from "./backgroundAxiosInstance";



class ApiService {
  static instance = null;
  
  constructor() {
    if (ApiService.instance) {
      return ApiService.instance;
    }
    this.axios = backgroundAxiosInstance;
    ApiService.instance = this;
  }
  
  static getInstance() {
    if (!ApiService.instance) {
      ApiService.instance = new ApiService();
    }
    return ApiService.instance;
  }
  
  async get(endpoint) {
    try {
      const response = await this.axios.get(endpoint);
      return response.data;
    } catch (error) {
      console.error(`API Error for ${endpoint}:`, error);
      throw error;
    }
  }
  
  async post(endpoint, data) {
    try {
      const response = await this.axios.post(endpoint, data);
      return response.data;
    } catch (error) {
      console.error(`API Error for ${endpoint}:`, error);
      throw error;
    }
  }
}

export default ApiService;